export default __webpack_public_path__ + "static/media/takeAPuntMobile.ce2fa923.png";